import { Injectable } from '@angular/core';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LgaDto } from '@cradua/data';

@Injectable({
  providedIn: 'root',
})
export class LgaService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}
  // method to get lga api
  getallLga(): Observable<LgaDto[]> {
    return this.http.get<LgaDto[]>(this.url + 'lga');
  }

  // method to get single lga
  getsinglelga(id: string): Observable<LgaDto> {
    return this.http.get<LgaDto>(this.url + 'lga/' + id);
  }

  // method to create lga api
  createlga(data: LgaDto[]): Observable<LgaDto[]> {
    return this.http.post<LgaDto[]>(this.url + 'lga', data);
  }

  // api method to update lga
  updatelga(data: LgaDto[]): Observable<LgaDto[]> {
    return this.http.post<LgaDto[]>(this.url + 'lga/update', data);
  }
  // delete lga api
  deleteLga(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('lga', ids.join(', '));
    return this.http.delete(this.url + 'lga', httpOptions);
  }
}
